<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.zsth">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">Bell Type Annealing Furnace</span>
        </b>
      </p>
      <p>
        <br>
      </p>
      <p style="background:white;">
        <span style="color:black;">Our products are exported to Ukraine and other countries.</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p style="background:white;">
        <span style="font-family:Arial;color:black;">&nbsp;</span>
      </p>
      <p style="background:white;">
        <span style="color:black;">1、</span>
        <b>
          <span style="font-family:Arial;color:#213C70;">
            <a href="http://www.dyhengli.com/zhaoshilu">
              <span style="font-family:宋体;">
                <span>Bright hood furnace</span>
              </span>
            </a>
          </span>
        </b>
        <span
          style="color:black;"
        >Mainly suitable for dozens of materials such as brass, bronze, copper, various types of precision copper tubes, coinage materials, precision strip steel, composite strip, soft magnetic and hard magnetic alloys, copper alloy wires, standard parts materials, stainless steel strips, etc. .</span>
        <span style="font-family:Arial;color:black;"></span>
        <span style="color:black;">The maximum charging diameter of the bright hood furnace is</span>
        <span style="font-family:Arial;color:black;">3.2M</span>
        <span style="color:black;">, the charging height is up to </span>
        <span style="font-family:Arial;color:black;">4M</span>
        <span style="color:black;">, and the maximum charging capacity is</span>
        <span style="font-family:Arial;color:black;">80T</span>
        <span style="color:black;">.</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p style="background:white;">
        <span style="font-family:Arial;color:black;">&nbsp;</span>
      </p>
      <p style="background:white;">
        <span style="color:black;">2、</span>
        <span style="font-family:Arial;color:black;">
          <a href="http://www.dyhengli.com/zhaoshilu">
            <strong>
              <span style="font-family:宋体;">
                <span>Bright hood furnace</span>
              </span>
            </strong>
          </a>
        </span>
        <span style="color:black;">Consists of a heating hood, two furnace bases, two inner hoods and a valve frame, etc..</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p style="background:white;">
        <span style="font-family:Arial;color:black;">
          <span>&nbsp;</span>
        </span>
      </p>
      <p style="background:white;">
        <span style="color:black;">3、The electric control cabinet adopts</span>
        <span style="font-family:Arial;color:black;">PID</span>
        <span style="color:black;">zero-cross trigger temperature control regulator to adjust the power and temperature in the furnace, and is equipped with an over-temperature alarm function</span>
        <span style="font-family:Arial;color:black;"></span>
        <span style="color:black;">. According to needs of customers, the upper computer can be made, and the configuration software displays dynamically.</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p style="background:white;">
        <span style="font-family:Arial;color:black;">&nbsp;</span>
      </p>
      <p style="background:white;">
        <span style="color:black;">Specific design can be customized according to customer workpiece product requirements.</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <img :src="images.zsth2" alt style="white-space:normal;">
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        zsth: require("../../../assets/img/common/zsth.jpg"),
        zsth2: require("../../../assets/img/common/zsth2.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/zsth.vue